import React, {useState} from 'react';
import './onboarding.css'
import WavePattern from '../../../../../../assets/svg/sidemenu/onboarding_wave_pattern.svg'
import {A8Logo } from '../../../../../../assets/svg/sidemenu/a8logo.js'
import { ReactComponent as LowLevelIcon } from '../../../../../../assets/svg/sidemenu/low_level_onboarding.svg'
import { ReactComponent as MidLevelIcon } from '../../../../../../assets/svg/sidemenu/mid_level_onboarding.svg'
import { ReactComponent as AdvancedLevel } from '../../../../../../assets/svg/sidemenu/advanced_level_onboarding.svg'
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../../../stateManager/store';
import { updateOnboarding } from '../../../../../../helpers/onboardingHelper';
import { setGuideVisible, setServiceTaskExist } from '../../../../../../stateManager/store/onboarding/action';
import { useHistory } from 'react-router-dom';
import Logo from '../../../../../../assets/svg/signIn_logos/uniphore-color.svg'



interface OnboardingHomeProps {
}

const onboardLevels = [
    {
        title: "Fundamental",
        content: "Gain proficiency in creating workflows by incorporating simple, interactive user forms.",
        Icon: LowLevelIcon,
        value: "basic"
    },
    {
        title: "Intermediate",
        content: "Learn to integrate service tasks into your workflow alongside user tasks.",
        Icon: MidLevelIcon,
        value: "midlevel"
    },
    {
        title: "Advanced",
        content: "Incorporate decision gateways to master the art of designing complex workflows.",
        Icon: AdvancedLevel,
        value: "advanced"
    }
]

const OnboardingHome: React.FC<OnboardingHomeProps> = ({  }) => {

    const [onboardLevel, setOnboardLevels] = useState(onboardLevels[0].value);
    const { info } = useSelector((state:AppState) => state.onboarding)
    const user = useSelector((state:AppState) => state.user.data.user)

    const dispatch = useDispatch();
    const history = useHistory()

    const skipTour = async() => {
        const payload = {
            ...info,
            skipTour: true
        }
        await updateOnboarding(user.userName, payload)
        dispatch(setGuideVisible(false))
        history.push("/home")
    }

    const startTour = async() => {
        if (!onboardLevel) {
            return null;
        }
        const payload = {
            ...info,
           level: onboardLevel
        }
        await updateOnboarding(user.userName, payload)
        dispatch(setGuideVisible(true))
        dispatch(setServiceTaskExist(false))
        history.push("/home")
    }
    return (
        <div className='w-full h-full fixed top-0 left-0' style={{ backgroundImage: `url(${WavePattern})`, width: "100%" , backgroundRepeat: "no-repeat", backgroundColor: "#F7F8FB"}}>
            <div className='w-full h-full flex justify-center'>
                <div className='flex flex-col select_onboard_const items-center justify-center w-[550px] h-4/5'>
                    {/* <div className='onboarding_logo h-[100px] w-[100px] pb-8'><A8Logo /></div> */}
                    <div className='onboarding_logo h-[100px] w-[100px] pb-8'><img src={Logo} style={{ height: 40, width: 200 }} /></div>
                   <span className='text-2xl leading-8 font-normal'>
                        Choose <b>Skill Level</b>
                   </span>
                   <div className='onboarding_card_selection'>
                        {
                            onboardLevels.map((level) => {
                                return (
                                    <div className={`onboarding_level_card  ${onboardLevel === level.value ? "onboarding_level_card_active" : " "}`} onClick={(()=> {setOnboardLevels(level.value)})}>
                                            <level.Icon/>
                                           <div className='onboarding_level_card_cnt'>
                                                <span>{level.title}</span>
                                                <p>{level.content}</p>
                                           </div>
                                    </div>
                                )
                            })
                        }
                   </div>
                   <div className='onboarding_card_selection_footer'>
                        <button onClick={(()=>{skipTour()})}>Skip</button>
                        <button onClick={()=>{startTour()}} className='onboarding_card_start'>Start</button>
                   </div>
                </div>
            </div>
        </div>
    );
};

export default OnboardingHome;
